export const video = [
  `https://www.dropbox.com/s/odzycivuo9cy5rg/video_01.mp4?dl=0`,
  `https://www.dropbox.com/s/7cx04n8rr4w5rbg/video_02.mp4?dl=0`,
];
